import styled from 'styled-components';
import {GeneralTitleBox} from '../../../../basic-components/general-title/general-title.box';
import {JACKPOT_WIDGET, RED_TIGER_JACKPOT} from '../../constants';

export const ListTitleTextDefaultBox = styled(GeneralTitleBox)`
    letter-spacing: 0.2rem;
    display: flex;
    align-items: center;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    color: ${props => props.theme.components.gamesListTitle.colors.text.regular};

    .${JACKPOT_WIDGET} & {
        color: ${props => props.theme.components.gamesListTitle.colors.text.dailyJackpot};
        border-left: 2px solid ${props => props.theme.components.gamesListTitle.colors.text.dailyJackpot};
    }

    .${RED_TIGER_JACKPOT} & {
        color: ${props => props.theme.components.gamesListTitle.colors.text.redTigerJackpot};
        border-left: 2px solid #ff014f;
    }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding-top: 0.6rem;
        padding-bottom: 0.6rem;
        padding-right: 0.1rem;
    }
`;
